import emailTemplateService from '../services/emailTemplateService';

const handleResponse = (result, fallbackMessage) => {
  if (!result?.success) {
    const error = new Error(result?.message || fallbackMessage);
    error.details = result;
    throw error;
  }
  return result;
};

export const fetchEmailTemplates = async (params) => {
  const result = await emailTemplateService.getEmailTemplates(params);
  const handled = handleResponse(result, 'E-posta şablonları alınamadı');
  return {
    data: handled.data,
    meta: handled.metaData,
  };
};

export const searchEmailTemplates = async ({ keyword } = {}) => {
  const result = await emailTemplateService.searchEmailTemplates({ keyword });
  return handleResponse(result, 'E-posta şablonları aranamadı').data;
};

export const fetchEmailTemplateById = async (id) => {
  const result = await emailTemplateService.getEmailTemplateById(id);
  return handleResponse(result, 'E-posta şablonu alınamadı').data;
};

export const createEmailTemplate = async (payload) => {
  const result = await emailTemplateService.createEmailTemplate(payload);
  return handleResponse(result, 'E-posta şablonu oluşturulamadı').data;
};

export const updateEmailTemplate = async (payload) => {
  const result = await emailTemplateService.updateEmailTemplate(payload);
  return handleResponse(result, 'E-posta şablonu güncellenemedi').data;
};

export const deleteEmailTemplate = async (id) => {
  const result = await emailTemplateService.deleteEmailTemplate(id);
  return handleResponse(result, 'E-posta şablonu silinemedi').data;
};

export default {
  fetchEmailTemplates,
  fetchEmailTemplateById,
  createEmailTemplate,
  updateEmailTemplate,
  deleteEmailTemplate,
};


